import { Navigate, useParams } from 'react-router-dom';

import { useGetNodo } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import SaveNodos from '../../shared/saveNodo/saveNodo';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateNodoPageInterface {}

const UpdateNodoPage: React.FC<UpdateNodoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_nodo)

  const { id } = useParams();
  const { data, isLoading } = useGetNodo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_nodo) return <Navigate to="/mantenimiento-operaciones/nodos" />;

  return <SaveNodos titlePage="Editar Nodo" editNodo={data.data} />;
};

export default UpdateNodoPage;
